"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAID = exports.OPEN = exports.CLOSED = void 0;
exports.CLOSED = "closed";
exports.OPEN = "open";
exports.PAID = "paid";